import axios from './axiosConfig.js';

export const productsApi = {
  getAll: async () => {
    const { data } = await axios.get('/products');
    return data;
  },
  add: async (productData) => {
    const { data } = await axios.post('/products', productData);
    return data;
  },
  update: async (id, productData) => {
    const { data } = await axios.put(`/products/${id}`, productData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/products/${id}`);
    return data;
  },
  resetStocks: async () => {
    const { data } = await axios.post('/products/reset-stocks');
    return data;
  },
};

export const employeeApi = {
  getAll: async () => {
    const { data } = await axios.get('/employees');
    return data;
  },
  add: async (employeeData) => {
    const { data } = await axios.post('/employees', employeeData);
    return data;
  },
  update: async (id, employeeData) => {
    const { data } = await axios.put(`/employees/${id}`, employeeData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/employees/${id}`);
    return data;
  },
  getById: async (id) => {
    const { data } = await axios.get(`/employees/${id}`);
    return data;
  },
};

export const clientApi = {
  getAll: async () => {
    const { data } = await axios.get('/clients');
    return data;
  },
  add: async (clientData) => {
    const { data } = await axios.post('/clients', clientData);
    return data;
  },
  update: async (id, clientData) => {
    const { data } = await axios.put(`/clients/${id}`, clientData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/clients/${id}`);
    return data;
  },
};

export const vendorApi = {
  getAll: async () => {
    const { data } = await axios.get('/vendors');
    return data;
  },
  add: async (vendorData) => {
    const { data } = await axios.post('/vendors', vendorData);
    return data;
  },
  update: async (id, vendorData) => {
    const { data } = await axios.put(`/vendors/${id}`, vendorData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/vendors/${id}`);
    return data;
  },
};

export const expenseApi = {
  getAll: async () => {
    const { data } = await axios.get('/expenses');
    return data;
  },
  add: async (expenseData) => {
    const { data } = await axios.post('/expenses', expenseData);
    return data;
  },
  update: async (id, expenseData) => {
    const { data } = await axios.put(`/expenses/${id}`, expenseData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/expenses/${id}`);
    return data;
  },
};

export const userApi = {
  getProfile: async () => {
    const { data } = await axios.get('/user/profile');
    return data;
  },
};

export const productionApi = {
  getAll: async () => {
    const { data } = await axios.get('/production');
    return data;
  },
  getMyProduction: async () => {
    const { data } = await axios.get('/production/my-production');
    return data;
  },
  add: async (productionData) => {
    const { data } = await axios.post('/production', productionData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/production/${id}`);
    return data;
  },
  update: async (id, prod) => {
    const { data } = await axios.put(`/production/${id}`, prod);
    return data;
  },
  clearAll: async (date) => {
    const { data } = await axios.delete('/production', { params: { date } });
    return data;
  }
};

export const attendanceApi = {
  getByDate: async (date) => {
    const { data } = await axios.get(`/attendance/${date}`);
    return data;
  },
  getByYear: async (year) => {
    const { data } = await axios.get(`/attendance/year/report/${year}`);
    return data;
  },
  getMyByYear: async (year) => {
    const { data } = await axios.get(`/attendance/my-attendance/year/${year}`);
    return data;
  },
  saveBulk: async (date, records) => {
    const { data } = await axios.post('/attendance/bulk', { date, records });
    return data;
  },
  getGeofence: async () => {
    const { data } = await axios.get('/attendance/geofence');
    return data;
  },
  punchAttendance: async (action, time, lat, lng) => {
    const payload = { action, time };
    if (lat !== undefined && lng !== undefined) {
      payload.lat = lat;
      payload.lng = lng;
    }
    const { data } = await axios.post('/attendance/punch', payload);
    return data;
  }
};

export const productionTargetApi = {
  getAll: async () => {
    const { data } = await axios.get('/production-targets');
    return data;
  },
  save: async (targetData) => {
    const { data } = await axios.post('/production-targets', targetData);
    return data;
  },
  updateProduced: async (id, producedQty) => {
    const { data } = await axios.put(`/production-targets/${id}`, { producedQty });
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/production-targets/${id}`);
    return data;
  },
  clearAll: async () => {
    const { data } = await axios.delete('/production-targets');
    return data;
  }
};

export const salesApi = {
  getAll: async () => {
    const { data } = await axios.get('/sales');
    return data;
  },
  log: async (saleData) => {
    const { data } = await axios.post('/sales', saleData);
    return data;
  },
  update: async (id, saleData) => {
    const { data } = await axios.put(`/sales/${id}`, saleData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/sales/${id}`);
    return data;
  },
  clearAll: async () => {
    const { data } = await axios.delete('/sales');
    return data;
  }
};
export const authApi = {
  updateProfile: async (profileData) => {
    const { data } = await axios.put('/auth/profile', profileData);
    return data;
  },
  changePassword: async (passData) => {
    const { data } = await axios.put('/auth/update-password', passData);
    return data;
  },
  getMySalary: async () => {
    const { data } = await axios.get('/auth/my-salary');
    return data;
  }
};

export const healthApi = {
  check: async () => {
    const { data } = await axios.get('/health');
    return data;
  }
};

export const notificationApi = {
  getAll: async () => {
    const { data } = await axios.get('/notifications');
    return data;
  },
  markRead: async (id) => {
    const { data } = await axios.put(`/notifications/${id}/read`);
    return data;
  },
  markAllRead: async () => {
    const { data } = await axios.put('/notifications/read-all');
    return data;
  },
  sendPush: async (payload) => {
    const { data } = await axios.post('/notifications/send', payload);
    return data;
  },
  respond: async (id, payload) => {
    const { data } = await axios.post(`/notifications/${id}/respond`, payload);
    return data;
  }
};

export const turnoverApi = {
  getSummary: async (params) => {
    const { data } = await axios.get('/turnover/analytics', { params });
    return data;
  },
  getAll: async () => {
    const { data } = await axios.get('/turnover');
    return data;
  },
  add: async (turnoverData) => {
    const { data } = await axios.post('/turnover', turnoverData);
    return data;
  },
  update: async (id, turnoverData) => {
    const { data } = await axios.put(`/turnover/${id}`, turnoverData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/turnover/${id}`);
    return data;
  }
};

export const rawMaterialApi = {
  getAll: async () => {
    const { data } = await axios.get('/raw-materials');
    return data;
  },
  add: async (materialData) => {
    const { data } = await axios.post('/raw-materials', materialData);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(`/raw-materials/${id}`);
    return data;
  }
};
